'use client';

import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-context';
import { decodeOrgCode, encodeOrgCode } from '@/lib/org-code';

// `/` 진입 시 활성 회사(compCd)의 경로 프리픽스로 정규화하는 디스패처.
//
// 반드시 <ProtectedRoute> 내부에서 렌더한다: ProtectedRoute가 인증 완료
// (isAuthenticated === true)를 보장하므로 keycloak init이 리다이렉트 백의
// ?code를 소비하기 전에는 이 컴포넌트가 마운트되지 않는다(정규화 리다이렉트가
// code 교환을 앞지르는 로그인 깨짐 방지).
//
// 정규 경로의 org는 요청 스코프(resolveEntryOrg)가 아니라 부여된 토큰 claim
// getCompanyCode()로 인코딩한다(거짓 URL 금지).
//
// getCompanyCode()가 compCd 도메인 패턴(대문자)이 아니면 encodeOrgCode
// 결과가 :orgCode 가드에서 decodeOrgCode→null로 거절되어 `/`로 되돌아온다.
// 그 경우 디스패처가 같은 세그먼트를 재생성해 무한 루프가 되므로, 여기서
// 가드와 동일한 decodeOrgCode로 왕복을 확인한 뒤에만 리다이렉트한다.
// (company_code claim은 유효 대문자 compCd로 가정한다 — org alias 대문자 컨벤션.)

// company_code claim이 없는 진입(조직 미지정)의 기본 조직.
const DEFAULT_COMP_CD = 'WJPNC';

export function OrgDispatcher() {
  // company_code claim이 없으면(조직 정보 없이 진입) 기본 조직으로 보낸다.
  // claim 없이 null을 반환하면 `/`가 아무것도 렌더하지 않아 빈 화면이 된다.
  const cc = useAuth().getCompanyCode() || DEFAULT_COMP_CD;
  const enc = encodeOrgCode(cc);

  if (decodeOrgCode(enc) === cc) {
    return <Navigate to={'/' + enc} replace />;
  }

  // 정규화 불가하면 현행 흐름에 위임한다.
  // (PENDING은 API 응답 403 → api-client가 /pending-approval로 리다이렉트)
  return null;
}

export default OrgDispatcher;
